<template>
  <div>
    <el-top-nav-menu-4
      :logo="logoBase"
      :companyTitle="title"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      ref="topNavMenu"
    >
    </el-top-nav-menu-4>

    <div class="main-wrapper">
      <div class="business-open-shop" style="padding-bottom: 50px">
        <div class="name-check" style="justify-content: center; height: auto">
          <div class="content-center" style="width: auto">
            <div
              :class="
                isActive >= item.active
                  ? 'content-block mryu block-active'
                  : 'content-block mryu'
              "
              v-for="(item, idx) in nameList"
              :key="idx"
              @click="clickStep(item.active)"
            >
              <div class="border-radius">
                <div
                  class="step-block"
                  style="font-family: PingFangSC-Semibold, PingFang SC"
                >
                  {{ item.active }}
                </div>
              </div>
              <span style="font-family: PingFangSC-Regular, PingFang SC">{{
                item.name
              }}</span>
              <ul v-if="idx < nameList.length - 1">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="active-box yu-flex">
          <div v-show="isActive == 1">
            <ready-info></ready-info>
          </div>
          <div v-show="isActive == 2">
            <apply-info ref="applyInfo"></apply-info>
          </div>
          <div v-show="isActive == 3" style="width: 100%">
            <pay-info ref="payInfo" @reloimg="reloimg"></pay-info>
          </div>
        </div>

        <div class="yu-flex yu-flex-col">
          <template v-if="orderPurchaseType != 10">
            <div
              style="font-size: 13px; color: #9b9b9b; margin: 20px"
              v-show="isActive == 1"
            >
              <el-checkbox
                v-model="checked"
                style="margin-right: 5px"
              />我已阅读并接受
              <span
                style="color: #f50b25; cursor: pointer"
                @click="shopagreementHand"
                >《商家入驻协议》</span
              >
            </div>
            <div
              v-if="checked && isActive == 1"
              class="data-bottom-btn"
              style="
                margin-bottom: 20px;
                font-family: PingFangSC-Semibold, PingFangSC;
                font-weight: 600;
              "
              @click="nextStepClick"
            >
              下一步
            </div>
            <div
              v-if="!checked && isActive == 1"
              class="data-bottom-btn1"
              style="
                margin-bottom: 20px;
                font-family: PingFangSC-Semibold, PingFangSC;
                font-weight: 600;
              "
            >
              下一步
            </div>
          </template>
          <div
            v-if="orderPurchaseType == 10 && isActive == 1"
            class="data-bottom-btn"
            style="
              margin: 20px;
              font-family: PingFangSC-Semibold, PingFangSC;
              font-weight: 600;
            "
            @click="nextStepClick"
          >
            下一步
          </div>

          <div
            v-show="isActive == 2"
            class="data-bottom-btn"
            style="
              margin-top: 20px;
              font-family: PingFangSC-Semibold, PingFangSC;
              font-weight: 600;
            "
            @click="saveApply"
          >
            提交申请
          </div>
        </div>

        <el-dialog
          class="dialog-center"
          title="提示"
          :visible.sync="dialogVisible2"
          :show-close="false"
          width="300px"
          show-divider
          show-shadow
          custom-class="el-dialog--customize"
        >
          <span>网络请求超时，请稍后再试</span>
          <span slot="footer" style="text-align: center">
            <el-button
              size="mini"
              type="primary-font-mini"
              @click="closeModalTimeout"
              >确定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
    <el-dialog
      title="商家入驻协议"
      :visible.sync="shopagreement"
      width="700px"
      show-divider
      show-shadow
      class="dialog-center"
      custom-class="el-dialog--customize"
    >
      <div v-if="agreementsUrl" style="height: 530px">
        <iframe
          :src="agreementsUrl + '#toolbar=0&view=FitH'"
          frameborder="0"
          style="width: 100%; height: 100%; overflow: auto"
        ></iframe>
      </div>
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="shopagreement = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import logoYc from "./images/logoYc.png";
import logoZl from "./images/logoZl.png";
import logoWl from "./images/logoWl.png";
import readyInfo from "./ready/index.vue";
import applyInfo from "./apply/index.vue";
import payInfo from "./pay/index.vue";
import {
  addShopByClp,
  shopSubmit,
  getWayChatPay,
  getStatus,
} from "@/api/lessor-open-shop.js";

export default {
  name: "index",
  components: {
    readyInfo,
    applyInfo,
    payInfo,
  },
  data() {
    return {
      checked: false,
      shopagreement: false,
      agreementsUrl: null,

      timer: null,
      applyData: {},
      title: "开店申请",
      // 8 云租 9 物流  10 二级集采
      obj: {
        8: "租赁商开店申请",
        9: "承运商开店申请",
        10: "二级集采开店申请",
      },
      orderPurchaseType: 8,
      baseUrl: "",
      logoBase: "",
      nameList: [
        { name: "注册须知", active: 1 },
        { name: "开店申请", active: 2 },
        { name: "扫码支付", active: 3 },
      ],
      isActive: 1,
    };
  },
  mounted() {
    console.log(process.env.NODE_ENV, "-*-*-process.env.NODE_ENV*-*--*-");
    console.log(this.getMoney(), "-*-*-this.getMoney*-*--*-");
    localStorage.removeItem("zipCodes");
    const { orderPurchaseType } = this.$route.query;
    if (orderPurchaseType) {
      this.orderPurchaseType = orderPurchaseType;
    }
    this.title = this.obj[this.orderPurchaseType];
    if (this.orderPurchaseType == 8) {
      this.baseUrl = this.$addUrlPerFix("yz.iccec.cn");
      this.logoBase = logoZl;
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/c6b15028026040288881f17ded4c127c.pdf";
    } else if (this.orderPurchaseType == 9) {
      this.baseUrl = this.$addUrlPerFix("wl.iccec.cn");
      this.logoBase = logoWl;
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/62432fc155c94de28ca724c2a2a3d49d.pdf";
    } else if (this.orderPurchaseType == 10) {
      this.logoBase = logoYc;
      this.baseUrl = this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL);
      this.agreementsUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/39686322c607476f9bf19adf3c5e765b.pdf";
    }

    //     商家入驻协议--物流
    // 10072796205
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/62432fc155c94de28ca724c2a2a3d49d.pdf

    // 商家入驻协议--云租.pdf
    // 10072794744
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/c6b15028026040288881f17ded4c127c.pdf

    // 商家入驻协议-中交云采.pdf
    // 10072796216
    // https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/39686322c607476f9bf19adf3c5e765b.pdf
  },
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    },
  },
  beforeRouteLeave(to, from, next) {
    // 在这里执行离开路由前的操作
    console.log("离开路由", from.path, "前往路由", to.path);
    // 清理数据或者保存状态
    clearInterval(this.timer);
    localStorage.removeItem("zipCodes");
    // 不要忘记调用 next() 方法来确认导航
    next();
  },
  methods: {
    nextStepClick() {
      this.isActive = 2;
      this.$refs.applyInfo.getMoRenBusinessName()
      
    },
    shopagreementHand() {
      this.shopagreement = true;
    },
    clickStep(active) {
      if (active == 1) {
        this.isActive = active;
      }
    },
    async saveApply() {
      const { applyInfo } = this.$refs;
      const applyData = await applyInfo.handleSubmit();
      this.applyData = applyData;
      addShopByClp({
        ...applyData,
        isShowLoading: true,
      }).then((res) => {
        if (res.data.code == 0) {
          this.isActive = 3;
          this.shopSubmit(this.applyData.phone, this.applyData.contactName);
        }
      });
    },
    reloimg() {
      clearInterval(this.timer);
      // 从新支付
      const zipCodes = localStorage.getItem("zipCodes");
      if (zipCodes) {
        this.getWayChatPay(
          zipCodes,
          this.applyData.contactName,
          this.applyData.phone
        );
      } else {
        this.$message.error("刷新失败，请重新注册！");
      }
    },
    getMoney() {
      const o = window.location;
      const hostname = o.hostname;
      const regex = /^([^-\s]*)/;
      const match = hostname.match(regex);
      switch (match[1]) {
        case "dev01": {
          return 0.01;
        }
        case "test01": {
          return 0.01;
        }
        case "uat01": {
          return 0.01;
        }
        default: {
          return 3000;
        }
      }
    },
    // 下单
    shopSubmit(phone, name) {
      const money = this.getMoney();

      const da = {
        submitBasicInfoBO: {
          orderPurchaseType: this.orderPurchaseType,
          orderType: 1,
          payType: 2,
          totalMoney: money,
          isShowLoading: true,
        },
        skuDetailInfoBOS: [
          {
            skuName: "店铺年服务费",
            purchaseCount: 1,
            sellingPrice: money,
            skuId: "999999999",
            total: money,
          },
        ],
        phone: phone,
        personName: name,
      };
      shopSubmit(da).then((res) => {
        if (res.data.code == 0) {
          console.log(res, "*-*-*-*-*");
          const { zipCodes } = res.data.data;
          localStorage.setItem("zipCodes", zipCodes);
          this.getWayChatPay(zipCodes, name, phone);
        }
      });
    },
    getWayChatPay(code, name, phone) {
      const das = {
        orderCodes: code,
        phone: phone,
        personName: name,
        isShowLoading: true,
      };
      getWayChatPay(das).then((res) => {
        this.$refs.payInfo.startDJS(res.data.data);

        this.timer = setInterval(() => {
          this.queryOrderPayStatus();
        }, 5000);
      });
    },
    // 支付状态查询
    queryOrderPayStatus() {
      const zipCodes = localStorage.getItem("zipCodes");
      getStatus({
        orderCodes: zipCodes, //加密后的订单编号
        phone: this.applyData.phone,
      }).then((res) => {
        if (res.data.code == 0) {
          // "allPay": 0 //是否支付成功  0未成功  1成功 2失败 3取消
          if (res.data.data.allPay == 1) {
            this.$message.success("支付成功！");
            clearInterval(this.timer);
            this.$refs.payInfo.paySuccess(res.data.data);
          }
        }
      });
    },
    closeModalTimeout() {
      this.$store.commit("SET_IS_SHOW_DIALOG_TIMEOUT", false);
    },
    goHomePage() {
      this.$router.push("/index");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .el-top-nav-menu4 {
  .sub-menu-wrapper-wrapper {
    .sub-menu-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
.name-check .content-center .mryu {
  margin-right: 120px;
  &:last-child {
    margin-right: 0;
  }
}
.yu-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.yu-flex-col {
  flex-direction: column;
}
.active-box {
  margin-top: 20px;
  background: #ffffff;
  padding: 20px 0;
}
.main-wrapper,
.headerContent {
  /*min-width: 1263px;*/
  /*max-width: 1680px;*/
  width: 1180px;
  margin: 0 auto;
}
/* header */
.header {
  cursor: pointer;
  /*min-width:  .main-wrapper1080px;*/
  /*max-width: 1680px;*/
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
.business-open-shop {
  /*padding: 0 50px 0 50px;*/
  /*margin-bottom: 20px;*/
}
</style>
  